interface IconNotFoundProps {
  className?: string
}
export const IconNotFound = ({ className }: IconNotFoundProps) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={125}
      height={146}
      viewBox='0 0 125 146'
      fill='none'
    >
      <g opacity='0.5'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M111.634 81.6161H13.4021V127.078C13.4021 129.246 14.824 131.159 16.9016 131.783C26.7715 134.742 54.5269 143.07 61.106 145.045C62.0269 145.32 63.0093 145.32 63.9302 145.045C70.5093 143.07 98.2647 134.742 108.135 131.783C110.212 131.159 111.634 129.246 111.634 127.078C111.634 115.693 111.634 81.6161 111.634 81.6161Z'
          fill='url(#paint0_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M111.634 81.6161H62.5181C62.5181 81.6161 62.0417 145.251 62.5181 145.251C62.9946 145.251 63.4685 145.182 63.9302 145.045C70.5093 143.07 98.2648 134.742 108.135 131.783C110.212 131.159 111.634 129.246 111.634 127.078C111.634 115.693 111.634 81.6161 111.634 81.6161Z'
          fill='url(#paint1_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M62.5181 97.5518L13.402 81.6161C13.402 81.6161 4.78956 94.3862 0.938862 100.094C0.506641 100.734 0.401042 101.538 0.651533 102.267C0.904481 102.996 1.48159 103.564 2.21588 103.804C11.5455 106.835 39.1634 115.808 46.408 118.161C47.4468 118.5 48.5863 118.109 49.2003 117.203C52.4935 112.343 62.5181 97.5518 62.5181 97.5518Z'
          fill='url(#paint2_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M111.634 81.6161L62.5181 97.5518C62.5181 97.5518 72.5426 112.343 75.8359 117.203C76.4498 118.109 77.5893 118.5 78.6281 118.161C85.8727 115.808 113.491 106.835 122.82 103.804C123.555 103.564 124.132 102.996 124.385 102.267C124.635 101.538 124.529 100.734 124.097 100.094C120.247 94.3862 111.634 81.6161 111.634 81.6161Z'
          fill='url(#paint3_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M50.6295 48.141C50.0155 47.2398 48.8785 46.8493 47.8397 47.1882C40.6 49.5384 12.9747 58.5143 3.64508 61.5473C2.91079 61.7855 2.33122 62.3528 2.08073 63.0821C1.83024 63.8115 1.93584 64.617 2.36806 65.2555C5.91424 70.5158 13.402 81.6161 13.402 81.6161L62.518 65.6264C62.518 65.6264 53.6968 52.6524 50.6295 48.141Z'
          fill='url(#paint4_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M122.668 65.2555C123.1 64.617 123.206 63.8115 122.955 63.0821C122.705 62.3528 122.125 61.7855 121.391 61.5473C112.061 58.5143 84.4361 49.5384 77.1964 47.1882C76.1576 46.8493 75.0205 47.2398 74.4066 48.141C71.3393 52.6524 62.5181 65.6264 62.5181 65.6264L111.634 81.6161C111.634 81.6161 119.122 70.5158 122.668 65.2555Z'
          fill='url(#paint5_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M111.634 81.6161L62.5181 65.6263L13.4021 81.6161L62.5181 97.5517L111.634 81.6161Z'
          fill='url(#paint6_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M62.5181 97.5517V65.6263L13.4021 81.6161L62.5181 97.5517Z'
          fill='url(#paint7_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M52.6505 72.6794C51.6289 72.0114 50.7079 71.2968 49.8902 70.5477C48.8931 69.6317 47.3386 69.698 46.4201 70.6975C45.5041 71.6946 45.5704 73.2491 46.5699 74.1651C47.5743 75.0885 48.7065 75.9677 49.9638 76.7904C51.0984 77.532 52.621 77.2128 53.3627 76.0782C54.1043 74.9436 53.7851 73.421 52.6505 72.6794Z'
          fill='url(#paint8_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M44.9982 65.1352C44.2688 64.1455 43.6524 63.1509 43.1465 62.1563C42.5326 60.948 41.0517 60.4667 39.8435 61.0806C38.6352 61.6946 38.1539 63.1754 38.7678 64.3837C39.3916 65.6067 40.148 66.8321 41.0444 68.0477C41.8474 69.1381 43.3847 69.3714 44.4776 68.5684C45.5679 67.7629 45.8012 66.2255 44.9982 65.1352Z'
          fill='url(#paint9_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M41.4079 55.113C41.4325 54.1233 41.5774 53.1631 41.8426 52.2422C42.2159 50.9406 41.4619 49.5776 40.1579 49.2043C38.8563 48.8311 37.4934 49.585 37.1201 50.889C36.7443 52.2053 36.5331 53.5781 36.4963 54.9902C36.4644 56.3458 37.5351 57.473 38.8907 57.5049C40.2463 57.5393 41.3735 56.4686 41.4079 55.113Z'
          fill='url(#paint10_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.1849 46.9106C45.816 46.3262 46.5233 45.7859 47.2969 45.2972C48.4437 44.5727 48.7876 43.055 48.0655 41.9106C47.3411 40.7638 45.8234 40.42 44.6765 41.142C43.6377 41.7977 42.6947 42.5221 41.8475 43.308C40.8529 44.2289 40.7939 45.7834 41.7148 46.778C42.6358 47.7726 44.1903 47.8316 45.1849 46.9106Z'
          fill='url(#paint11_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M54.318 42.6744C55.5533 42.446 56.8622 42.2987 58.2424 42.2422C59.598 42.1832 60.649 41.0364 60.5926 39.6832C60.5361 38.3301 59.3892 37.2766 58.0336 37.333C56.4128 37.4018 54.8755 37.5762 53.4241 37.8438C52.093 38.0919 51.209 39.3738 51.457 40.7049C51.7026 42.0384 52.9845 42.92 54.318 42.6744Z'
          fill='url(#paint12_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M67.1177 42.5295C69.2125 42.554 71.1624 42.4803 72.9723 42.3207C74.323 42.2004 75.3225 41.0069 75.2022 39.6562C75.0819 38.3079 73.8883 37.3084 72.5377 37.4288C70.88 37.5737 69.0946 37.6424 67.1742 37.6179C65.8186 37.6031 64.7061 38.691 64.6914 40.0442C64.6742 41.3998 65.7621 42.5147 67.1177 42.5295Z'
          fill='url(#paint13_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M81.0446 40.8154C83.4758 40.0713 85.5289 39.1184 87.2479 38.0256C88.3899 37.2962 88.7288 35.7785 87.9994 34.6341C87.2725 33.4922 85.7523 33.1533 84.6079 33.8826C83.2253 34.7618 81.5677 35.5182 79.6079 36.1174C78.3137 36.5153 77.5819 37.8881 77.9797 39.1847C78.3751 40.4814 79.7504 41.2107 81.0446 40.8154Z'
          fill='url(#paint14_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M93.5445 31.1518C94.7036 28.7549 95.1482 26.2206 95.0352 23.777C94.9713 22.4214 93.8196 21.3753 92.4664 21.4391C91.1133 21.503 90.0646 22.6523 90.1285 24.0054C90.2071 25.6655 89.9075 27.3871 89.1216 29.0153C88.5322 30.2358 89.043 31.7068 90.2636 32.2962C91.4841 32.8856 92.9551 32.3723 93.5445 31.1518Z'
          fill='url(#paint15_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M91.9803 15.0933C90.19 12.6744 87.7612 10.9897 85.1139 10.4469C83.7853 10.1768 82.4862 11.0314 82.2136 12.36C81.9434 13.6886 82.8005 14.9877 84.1266 15.2603C85.6541 15.5722 86.9999 16.6208 88.0338 18.0182C88.8418 19.1061 90.3816 19.3345 91.4695 18.529C92.5599 17.721 92.7882 16.1812 91.9803 15.0933Z'
          fill='url(#paint16_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M59.8977 10.9234C62.5549 -4.12332 85.5829 -3.15082 72.1767 10.9234H59.8977Z'
          fill='url(#paint17_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M59.8977 14.7347C62.5549 29.779 85.5829 28.8089 72.1767 14.7347H59.8977Z'
          fill='url(#paint18_linear_8_5900)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M59.6767 15.3094H76.1208C77.4764 15.3094 78.5766 14.2092 78.5766 12.8536C78.5766 11.498 77.4764 10.3978 76.1208 10.3978H59.6767C58.3236 10.3978 57.2209 11.498 57.2209 12.8536C57.2209 14.2092 58.3236 15.3094 59.6767 15.3094Z'
          fill='url(#paint19_linear_8_5900)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_8_5900'
          x1='13.4021'
          y1='113.433'
          x2='111.634'
          y2='113.433'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CADCF0' />
          <stop offset={1} stopColor='#A4BBDB' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_8_5900'
          x1='62.3069'
          y1='113.433'
          x2='111.634'
          y2='113.433'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A4BBDB' />
          <stop offset={1} stopColor='#8DA3BE' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_8_5900'
          x1='13.7287'
          y1='81.5964'
          x2='20.5932'
          y2='127.012'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9F3FC' />
          <stop offset={1} stopColor='#CADCF0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_8_5900'
          x1='62.717'
          y1='97.3848'
          x2='114.494'
          y2='127.164'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9F3FC' />
          <stop offset={1} stopColor='#CADCF0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_8_5900'
          x1='6.97269'
          y1='72.0851'
          x2='14.3819'
          y2='37.158'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9F3FC' />
          <stop offset={1} stopColor='#CADCF0' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_8_5900'
          x1='75.6664'
          y1='46.5963'
          x2='78.3158'
          y2='89.7073'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9F3FC' />
          <stop offset={1} stopColor='#CADCF0' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_8_5900'
          x1='13.4021'
          y1='81.589'
          x2='111.634'
          y2='81.589'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CADCF0' />
          <stop offset={1} stopColor='#A4BBDB' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_8_5900'
          x1='67.5476'
          y1='64.9117'
          x2='68.606'
          y2='104.58'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A4BBDB' />
          <stop offset={1} stopColor='#8DA3BE' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_8_5900'
          x1='35.482'
          y1='10.9234'
          x2='83.9202'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_8_5900'
          x1='35.482'
          y1='10.9233'
          x2='83.9202'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_8_5900'
          x1='35.4821'
          y1='10.9233'
          x2='83.9203'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_8_5900'
          x1='35.482'
          y1='10.9233'
          x2='83.9202'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_8_5900'
          x1='35.482'
          y1='10.9233'
          x2='83.9202'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_8_5900'
          x1='35.4821'
          y1='10.9233'
          x2='83.9202'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_8_5900'
          x1='35.4821'
          y1='10.9234'
          x2='83.9203'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_8_5900'
          x1='35.482'
          y1='10.9234'
          x2='83.9202'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_8_5900'
          x1='35.4821'
          y1='10.9234'
          x2='83.9203'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_8_5900'
          x1='59.8977'
          y1='5.46167'
          x2='76.3393'
          y2='5.46167'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9F3FC' />
          <stop offset={1} stopColor='#CADCF0' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_8_5900'
          x1='59.8977'
          y1='20.1964'
          x2='76.3393'
          y2='20.1964'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9F3FC' />
          <stop offset={1} stopColor='#CADCF0' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_8_5900'
          x1='35.4822'
          y1='10.9234'
          x2='83.9204'
          y2='68.0772'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#559AFF' />
          <stop offset={1} stopColor='#2E69EF' />
        </linearGradient>
      </defs>
    </svg>
  )
}
